import React, {useEffect, useState} from 'react';
import './SelectedFromTable.scss';
import DynaTable from "../../../../MyTable/DynaTable";
import Loader from "../../../../Loader";
import Modal, {ModalBody, ModalHeader} from "../../../../Modal";
import ModalBodyAddDetails from "../../TableDetailCoding/ModalDataChanger/ModalBodyAddDetails";
import ModalBodyEditDetails from "../../TableDetailCoding/ModalDataChanger/ModalBodyEditDetails";
import ModalBodyDeleteDetails from "../../TableDetailCoding/ModalDataChanger/ModalBodyDeleteDetails";
import {toast} from "react-toastify";
import GetBillDataInTableDataChanger from "../TableDataChanger/GetBillDataInTableDataChanger";

const SelectedFromTable = (props) => {

    const {floatingAccountCode} = props.floatingData;
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [modalData, setModalData] = useState({
        title: "بدون عنوان", body: <></>, type: "add",// or Edit
    })
    const [currentRowData, setCurrentRowData] = useState({});
    const [componentData, setComponentData] = useState({});
    const [searchValue, setSearchValue] = useState("");
    const [optionValue, setOptionValue] = useState("");

    useEffect(() => {

        if (searchValue !== "" && optionValue !== "") {
            const filtered = props.floatingData.floatingAccountsList.data.filter((item) => {
                    const selectedItem = item[optionValue]
                    return selectedItem.toLowerCase().includes(searchValue.toLowerCase())
                }
            );
            setComponentData({column: props.floatingData.floatingAccountsList.column, data: filtered});
        } else {
            setComponentData({
                column: props.floatingData.floatingAccountsList.column,
                data: props.floatingData.floatingAccountsList.data
            });
        }
    }, [searchValue, optionValue, props.floatingData.floatingAccountsList]);

    let editModalHandler = (floatingAccountCode, newValue, id) => {
        props.editHandler(floatingAccountCode, newValue, id)
        setIsOpenModal(false)
        setCurrentRowData({})
    };
    let addModalHandler = (value, id, floatingAccountCode) => {
        props.addHandler(value, id, floatingAccountCode)
        setIsOpenModal(false)
    };

    const deleteModalHandler = (floatingAccountCode, id) => {
        props.deleteHandler(floatingAccountCode, id)
        setIsOpenModal(false)
        setCurrentRowData({})
    }

    let closeModal = () => {
        setIsOpenModal(false)
    };

    const addFloatingHandler = () => {
        setModalData({
            type: "add", id: "", floatingAccountCode: floatingAccountCode, title: "", modalTitle: "افزودن شناوری",
        });
        setIsOpenModal(true)
    }
    const editFloatingHandler = () => {
        if (Object.keys(currentRowData).length > 0) {
            setModalData({
                type: "edit",
                id: currentRowData?.CODE_SHEN,
                floatingAccountCode: floatingAccountCode,
                title: currentRowData?.ONVAN_SHEN,
                modalTitle: "ویراش شناوری",
            });
            setIsOpenModal(true)
        } else {
            toast("لطفا یک سطر شناوری را انتخاب کنید")
        }
    }
    const deleteFloatingHandler = () => {
        if (Object.keys(currentRowData).length > 0) {
            setModalData({
                type: "delete",
                id: currentRowData?.CODE_SHEN,
                floatingAccountCode: floatingAccountCode,
                title: currentRowData?.ONVAN_SHEN,
                modalTitle: "حذف شناوری",
            });
            setIsOpenModal(true)
        } else {
            toast("لطفا یک سطر شناوری را انتخاب کنید")
        }
    }

    return (
        <>
            <Modal
                isOpen={isOpenModal}
                modalCallback={() => setIsOpenModal(false)}
                widthProp={600}
            >
                <ModalHeader title={modalData.modalTitle}/>

                <ModalBody>
                    <>
                        <div className={""}
                             style={{
                                 padding: "5px",
                                 overflow: "scroll",
                                 margin: "auto",
                                 width: '500px',
                             }}>
                            {

                                modalData.type === "add" ? <>
                                    <ModalBodyAddDetails
                                        modalData={modalData}
                                        addHandler={addModalHandler}
                                        closeModal={closeModal}
                                    />
                                </> : modalData.type === "edit" ? <>
                                    <ModalBodyEditDetails
                                        modalData={modalData}
                                        editHandler={editModalHandler}
                                        closeModal={closeModal}
                                    /> </> : modalData.type === "delete" ? <>
                                    <ModalBodyDeleteDetails
                                        modalData={modalData}
                                        deleteHandler={deleteModalHandler}
                                        closeModal={closeModal}
                                    />
                                </> : <></>}
                        </div>
                    </>
                </ModalBody>
            </Modal>

            <div className="float-area">

                <div className="table-area">

                    {!props.floatingData.isLoading ?
                        <>
                            {Object.keys(componentData).length > 0 &&
                                <DynaTable
                                    column={componentData?.column}
                                    data={componentData?.data}
                                    className={"solid-table"}
                                    priceFields={props?.floatingData.floatingAccountsList?.priceFields}
                                    onRowClick={(rowData) => setCurrentRowData(rowData)}/>
                            }
                        </> :
                        <Loader/>}

                </div>

                <div className="left-side-area">

                    <div className="filters-side">

                        <div className="select-filter">
                            <select value={optionValue} onChange={(event) => {
                                setOptionValue(event.target.value)
                            }}>
                                <option value="" selected disabled hidden>انتخاب کنید ...</option>
                                {props.floatingData.floatingAccountsList.column.map((v, index) =>
                                    <option key={"O" + index} value={v.field}>{v.title}</option>
                                )}
                            </select>
                        </div>

                        <input type="text" value={searchValue} onChange={(event) => {
                            setSearchValue(event.target.value)
                        }}/>

                    </div>

                    <div className="button-side">

                        <div className="button-styl" onClick={addFloatingHandler}>
                            <p>شناوری جدید</p>
                        </div>

                        <div className="button-styl" onClick={editFloatingHandler}>
                            <p>ویراش شناوری</p>
                        </div>

                        <div className="button-styl" onClick={deleteFloatingHandler}>
                            <p>حذف شناوری</p>
                        </div>

                      <GetBillDataInTableDataChanger  selectedRow={currentRowData} whichKey={"CODE_SHEN"} type={'floatingAccount'} />
                    </div>
                </div>
            </div>
        </>
    );
};
export default SelectedFromTable;